import * as React from 'react';
import localStoradge from "../../js/localStoradge";
import { connect } from 'react-redux'
import {deactivate, setScreen} from "../actions/activation";
import {updateGloop} from "../actions/update";
import {loading as Loading} from "../actions/ui";

class StartBlockComponent extends React.Component {
    state = {
        mutedVideo : true
    };
    render() {
        const {activeGloopOptions, ui,gloop,options,videoVersion} = this.props;
        const loading = (!activeGloopOptions || activeGloopOptions.status == 'loading') ? ' loading' : '' ;
        const counter = String(activeGloopOptions ? activeGloopOptions.id : '').split('-').length;
        const number = String(activeGloopOptions ? activeGloopOptions.id : '').split('-')[1];
        const urlFinish = String('-' + number + '.mp4');
        return (
            <div className={'gloop-start-block'}>
                <div onClick={() => {
                    window.jQuery('body').css({position : 'static'});
                    deactivate();
                }} className={'gloop-overlay'}>
                </div>
                <div className={('gloop-container-2' /*+ loading*/)}>
                    {loading ? (
                        <div className={'loading'}>
                            <p>Please wait...</p>
                            <img src={(activeGloopOptions && activeGloopOptions.data) ? activeGloopOptions.data.image : ''}
                                 width={'100%'}/>
                        </div>
                    ) : ''}
                    <div className="gloop-top-bar">
                        <a
                            href={'#'}
                            className={'gloop-back-button'}
                            onClick={deactivate}
                        >Back</a>
                        <a
                            href={'#'}
                            className={'gloop-share btt'}
                            onClick={() => {
								window.fbq('trackCustom', 'EditorShare', {
                                    content_ids: options.id,
                                    content_name: options.data.postTitle,
                                    content_author: options.data.author,
                                    content_type:'product'
                                });
                                window.dataLayer.push({
                                    'event': 'share_click',
                                    'event_trigger': 'editor_open',
                                    'content_id': options.id,
                                    'content_name': options.data.postTitle,
                                    'content_author': options.data.author,
                                    'content_type': 'product'
                                });
                                setScreen(!gloop.data.saved && !gloop.post_date ? 'shareStart' : 'share');
                            }}
                        >SEND</a>
                    </div>
                    <div className="gloop-animation-block">
                        {gloop && gloop.data ?
                            <video
                                ref="vidRef"
                                onPlay={(event) => {
                                    Loading(false);
                                }}
                                poster={(activeGloopOptions && activeGloopOptions.data)  ? activeGloopOptions.data.image : ''}
                                autoPlay={true}
                                width="375"
                                loop={true}
                                muted={this.state.mutedVideo}
                                playsinline=""
                                controls={false}
                                onError={(e) =>{
                                    this.refs.vidRef.src =  activeGloopOptions && activeGloopOptions.data ?
                                    (activeGloopOptions.data.storyVideo ? activeGloopOptions.data.storyVideo : activeGloopOptions.data.v)
                                    : '';
                                    this.refs.vidRef.play();
                                }}
                            >
                                { activeGloopOptions && activeGloopOptions.data ?
                                    <source type="video/mp4" src={(/*!window.UserId &&*/ !gloop.data.saved && !gloop.post_date)?
                                        ( activeGloopOptions && activeGloopOptions.data ?
                                            (activeGloopOptions.data.storyVideo ? ((counter < 2) ? activeGloopOptions.data.storyVideo : String(activeGloopOptions.data.storyVideo).replace('.mp4', urlFinish)) : activeGloopOptions.data.v)
                                            : '')
                                        : gloop.data.customization_url.replace('download.','')+'?ver='+videoVersion} />
                                    : ''

                                }
                            </video>
                            : ''}
                        <div className={'volume-wrapper'} onClick={(e)=>{
                            this.setState({
                                mutedVideo : !this.state.mutedVideo
                            })
                        }}
                        ><div className={'volume-button' + (this.state.mutedVideo ? '' : ' sound')}></div></div>
                    </div>
                    <div className={"gloop-startblock-content"}>
                        {gloop && gloop.data && gloop.data.shared ? [
                            <h2>Glad you`re back here!</h2>,
                            <p>So great to share this Toing again or continue and edit it`s text, style, animation and soundtrack.</p>
                        ] : [
                            <h2>Glad you’re here!</h2>,
                            <p>Share this Toing or continue and edit it’s text, style, animation and soundtrack.</p>
                        ]}
                        <div className={"gloop-start-editing"}>
                            <a
                                href="#"
                                onClick = {(event) => {
                                    event.preventDefault();
                                    window.fbq('trackCustom', 'EditorEdit', {
                                        content_ids: options.id,
                                        content_name: options.data.postTitle,
                                        content_author: options.data.author,
                                        content_type: 'product'
                                    });
                                    window.dataLayer.push({
                                        'event': 'edit_click',
                                        'event_trigger': 'editor_open',
                                        'content_id': options.id,
                                        'content_name': options.data.postTitle,
                                        'content_author': options.data.author,
                                        'content_type': 'product'
                                    });
                                    setScreen('gloop');
                                    updateGloop({},true);
                                }}
                            >MAKE IT YOUR OWN</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const gloop = state.gloops[state.activeGloop];
	let options = {};
	if(gloop && gloop.data){
		options = state.gloopsOptions[gloop.data.original_gloop[0]]
	}
    return {
	    gloop: gloop,
        activeGloopOptions : options,
        ui : state.ui,
        options :options,
        videoVersion : state.videoVersion,
        activeGloop : state.activeGloop
    };
}
const StartBlock = connect(mapStateToProps)(StartBlockComponent)
export default StartBlock;
